/**
 * MODULES - sticky scroller - NOT READY TO USE IN OTHER PROJECTS ( VERY INDIVIDUAL BEHAVIOR)
 * @author PLEJ
 */
import { breakpoint } from "../common/breakpoint";

const stickyScroller = (() => {
  let startScrolling = 0;
  let endScrolling = 0;
  const area = document.querySelector("[sticky-scroll-area]");
  const stickyItems = document.querySelectorAll("[sticky-scroll-item]");
  let activeItem = null;

  let itemsArray = [];

  const init = () => {
    if (breakpoint.large("up") && area) {
      initEvents();
    }
  };

  const initEvents = () => {
    window.addEventListener("scroll", () => handleScroll());
    window.addEventListener("resize", processItems);
    processItems();
  };

  const processItems = () => {
    itemsArray = [];

    stickyItems.forEach((item) => {
      const innerRect = item
        .querySelector("[sticky-scroll-item-inner]")
        .getBoundingClientRect();
      const temp = {
        element: item,
        imgUrl: item.getAttribute("sticky-scroll-item"),
        imgCanvas: item.querySelector(".sticky-img img"),
        innerRectTop: innerRect.top + window.scrollY,
        innerRectBottom: innerRect.bottom + window.scrollY,
        itemRectTop: item.getBoundingClientRect().top + window.scrollY,
        itemRectBottom: item.getBoundingClientRect().bottom + window.scrollY
      };

      itemsArray.push(temp);
      activeItem = scrollIntoView(temp) ? temp : activeItem;
    });
    setBasics(activeItem);
  };

  const handleScroll = () => {
    if (!startScrolling || !endScrolling) return;

    if (
      window.pageYOffset >= startScrolling &&
      window.pageYOffset <= endScrolling
    ) {
      area.classList.add("in-view");
      area.classList.remove("out-of-view");
      itemsArray.forEach((item, index) => {
        if (scrollIntoView(item)) {
          if (activeItem !== item) {
            if (activeItem) {
              activeItem.imgCanvas.classList.remove("on-top");
            }
            activeItem = item;
            item.imgCanvas.classList.add("on-top");
          }
        }
      });
    } else {
      area.classList.remove("in-view");

      if (window.pageYOffset > endScrolling) {
        area.classList.add("out-of-view");
      }
    }
  };

  const setBasics = (item) => {
    startScrolling = itemsArray[0].itemRectTop;
    endScrolling = itemsArray[itemsArray.length - 1].itemRectTop;

    if (item) {
      item.imgCanvas.classList.add("on-top");
    } else {
      // set first / last item visible depends on init scroll position
      if (window.pageYOffset < itemsArray[0].innerRectTop) {
        itemsArray[0].imgCanvas.style.opacity = 1;
      } else {
        itemsArray[itemsArray.length - 1].imgCanvas.style.opacity = 1;
      }
    }
  };

  const scrollIntoView = (item) =>
    item.innerRectTop > window.scrollY &&
    item.innerRectBottom <= window.scrollY + window.innerHeight;

  return {
    init
  };
})();

export { stickyScroller };
